/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.fts.js
Source: slb_src/slices/fts/
Build: slb_build/build_fts.mjs
Built: 2026-09-19 16:54:02.069Z
Content-SHA256: 9f040940195a840220d5241401fb4c47b547e763c5daaa86b02416ee79ed04a7
Content-SHA256-12: 9f040940195a
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.fts.js
*/

/* SLB Fan Tai Sui page (calculator + temple order submit)
   - Safe isolated module
   - Uses lunar-javascript CDN
*/
(function(){
  if(!document.getElementById('slbFanTaiSuiPanel')) return;

  const getApp = ()=> (window.SLB_APP || window.SLBAPP || window.slbApp || null);
  async function rpc(action,args){
    const app = getApp();
    if(!app || !app.rpc) throw new Error('SLB app not ready');
    return await app.rpc(action, args||{});
  }


  const LUNAR_URL = "https://cdn.jsdelivr.net/npm/lunar-javascript@1.7.7/lunar.js";
  let __slbFtsLunarLoading = false;

  function loadScriptOnce(url){
    return new Promise((resolve, reject) => {
      // already loaded
      const existing = Array.from(document.scripts||[]).find(s => (s.src||"") === url);
      if(existing) return resolve();

      const s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.setAttribute('data-slb-managed-resource', 'fts-calendar-vendor');
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Failed to load calendar engine."));
      document.head.appendChild(s);
    });
  }

  function waitFor(fn, timeoutMs){
    const start = Date.now();
    return new Promise((resolve, reject) => {
      (function tick(){
        if(fn()) return resolve();
        if(Date.now()-start > timeoutMs) return reject(new Error("Calendar engine blocked. Please use Chrome / Safari (not in-app browser)."));
        setTimeout(tick, 60);
      })();
    });
  }

  function softShowAlert(msg){
    const box = document.getElementById("alertBox");
    if(!box) return;
    box.textContent = String(msg||"");
    box.style.display = "block";
  }

  async function boot(){
    try{
      if(typeof Solar === "undefined" || typeof Lunar === "undefined"){
        if(!__slbFtsLunarLoading){
          __slbFtsLunarLoading = true;
          await loadScriptOnce(LUNAR_URL);
        }
        await waitFor(() => (typeof Solar !== "undefined"), 3500);
      }
    }catch(e){
      softShowAlert((e && e.message) ? e.message : String(e||""));
      // still proceed; the calculator will show a clear error on Confirm
    }

    // Main app (ported from reference page, with SLB payment submit)
  const ITEM_ID = "tai-sui";
  const BASE_OFFER = 108;
  const $ = (id) => document.getElementById(id);

  let lastData = null;
  let mode = "suggested";

  const alertBox = $("alertBox");
  const successBox = $("ftsPayMsg") || $("successBox");
  const worshipNext = $("ftsWorshipNext");

  function showAlert(msg){ if(!alertBox) return; alertBox.textContent=String(msg||""); alertBox.style.display="block"; }
  function hideAlert(){ if(!alertBox) return; alertBox.textContent=""; alertBox.style.display="none"; }
  function showSuccess(msg){
    if(successBox){
      if(msg!=null) successBox.textContent=String(msg);
      successBox.style.display="block";
    }
    if(worshipNext) worshipNext.style.display="block";
  }
  function hideSuccess(){
    if(successBox){ successBox.textContent=""; successBox.style.display="none"; }
    if(worshipNext) worshipNext.style.display="none";
  }

  function pad2(n){ return String(n).padStart(2,"0"); }
  function clampInt(val,min,max){ let n=parseInt(val,10); if(isNaN(n)) n=min; return Math.max(min, Math.min(max,n)); }

  function bindTap(el, fn){
    if(!el) return;
    const wrapped = async (ev) => {
      try{ ev && ev.preventDefault && ev.preventDefault(); }catch(e){}
      try{ await fn(); }catch(e){
        showAlert((e && e.message) ? e.message : "Error. Please refresh and try again.");
      }
    };
    el.addEventListener("click", wrapped, { passive:false });
    el.addEventListener("touchend", wrapped, { passive:false });
    el.addEventListener("pointerup", wrapped, { passive:false });
  }

  function safeCall(obj, names, fallback=""){
    for(const n of names){
      if(obj && typeof obj[n] === "function"){
        try { return obj[n](); } catch(e){}
      }
    }
    return fallback;
  }

  function makeSolar(y,m,d,hh,mm){
    const dateObj = new Date(y, m-1, d, hh||0, mm||0, 0);
    if (typeof Solar !== "undefined" && typeof Solar.fromDate === "function") return Solar.fromDate(dateObj);
    if (typeof Solar !== "undefined" && typeof Solar.fromYmdHms === "function") return Solar.fromYmdHms(y,m,d,hh||0,mm||0,0);
    return Solar.fromYmd(y,m,d);
  }

  function branchFromGanZhi(gz){ return (!gz || gz.length < 2) ? "" : gz.substring(1,2); }

  const FAN_BRANCHES = {
    "午": { animal:"Horse",   type:"當太歲" },
    "子": { animal:"Rat",     type:"沖太歲" },
    "丑": { animal:"Ox",      type:"刑太歲" },
    "卯": { animal:"Rabbit",  type:"害太歲" },
    "酉": { animal:"Rooster", type:"破太歲" }
  };

  function fanCheck(label, zhiChar){
    if(!zhiChar) return { text: `${label}: -`, hit:false, zhi:"" };
    const hit = !!FAN_BRANCHES[zhiChar];
    if(!hit) return { text: `${label}: ${zhiChar} (not on 2026 list)`, hit:false, zhi:zhiChar };
    const info = FAN_BRANCHES[zhiChar];
    return { text: `${label}: ${zhiChar} → ${info.animal} (${info.type})`, hit:true, zhi:zhiChar, info };
  }

  function buildSuggestions(checks, hasTime){
    const out=[];
    if(checks.year.hit)  out.push({fu:1, text:"Year hit: set 1 Fan Tai Sui FU as Tai Sui altar at home."});
    if(checks.month.hit) out.push({fu:1, text:"Month hit: place 1 Fan Tai Sui FU at bedroom or main entrance."});
    if(checks.day.hit)   out.push({fu:1, text:"Day hit: carry 1 Fan Tai Sui FU on your body."});
    if(hasTime && checks.time.hit) out.push({fu:1, text:"Time hit: 1 Fan Tai Sui FU for distance burn into Yuen Sun."});
    return out;
  }

  function renderSuggestList(items){
    const ul = $("suggestList");
    ul.innerHTML="";
    if(!items.length){
      const li=document.createElement("li");
      li.textContent="No Fan Tai Sui hit. (Minimum 0)";
      ul.appendChild(li);
      return;
    }
    items.forEach(it=>{
      const li=document.createElement("li");
      li.textContent=it.text;
      ul.appendChild(li);
    });
  }

  function setMode(next){
    mode=next;
    hideSuccess();
    $("suggestModeBox").style.display = (mode==="suggested") ? "block" : "none";
    $("customModeBox").style.display  = (mode==="custom") ? "block" : "none";
    refreshAll();
  }

  function getSuggestedBase(minNeed){ return Math.max(1, minNeed); }

  function getCurrentQuantity(){
    if(!lastData) return 1;
    if(mode==="custom") return clampInt($("qty").value,1,99);
    const base = getSuggestedBase(lastData.minNeed);
    const extra = clampInt($("extraQty").value,0,99);
    return clampInt(base+extra,1,99);
  }

  function refreshOfferingLine(){
    const line = $("ftsTotalLine");
    if(!line) return;
    const qty = getCurrentQuantity();
    const topUp = clampInt(($("ftsTopUp")||{}).value, 0, 999999);
    const total = (BASE_OFFER + topUp) * qty;
    line.textContent = `Total offering: ${total} stones ( ${BASE_OFFER} + ${topUp} ) × ${qty}`;
  }

  async function loadPouches(){
    const sel = $("ftsPouchSel");
    if(!sel) return;
    if(sel.dataset.loaded==="1" || sel.dataset.loading==="1") return;
    sel.dataset.loading="1";

    try{
      // Wait for SLB app rpc to be ready (important on first load)
      await waitFor(()=>{ const a=getApp(); return !!(a && typeof a.rpc==="function"); }, 6500);

      const out = await rpc("templeGet", {});
      const pouches = (out && out.pouches) || [];
      const opts = ['<option value="">Select a pouch...</option>'];

      for(const p of pouches){
        const id = String(p.accountId||p.walletId||"").trim();
        if(!id) continue;
        const name = String(p.name||p.label||id).trim();
        const bal = Number(p.balance||0)||0;
        opts.push(`<option value="${id}">${escapeHtml(name)} — ${bal} stones</option>`);
      }

      sel.innerHTML = opts.join("");
      sel.dataset.loaded="1";
    }catch(e){
      // Allow retry (do not permanently mark as loaded)
      sel.dataset.loaded="0";
    }finally{
      sel.dataset.loading="0";
    }
  }

  function escapeHtml(s){
    return String(s||"").replace(/[&<>"']/g, (c)=>({ "&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;" }[c]));
  }


  function formatWesternPretty(dob,tob,hasTime){
    const months=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const p=dob.split("-").map(n=>parseInt(n,10));
    const y=p[0], m=p[1], d=p[2];
    const mon=months[(m||1)-1]||"???";
    return hasTime ? `${y} ${mon} ${d} ${tob}` : `${y} ${mon} ${d}`;
  }

  function buildCompactNoteLine(){
    if(!lastData) return "";

    const westernPretty = formatWesternPretty(lastData.dob, lastData.tob, lastData.hasTime);
    const gzTimePart = lastData.hasTime ? (lastData.gzTime || "-") : "-";
    const gzStr = `${lastData.gzYear || "-"} / ${lastData.gzMonth || "-"} / ${lastData.gzDay || "-"} / ${gzTimePart}`;

    const ftsParts=[];
    if(lastData.checks.year.hit)  ftsParts.push(`Year: ${lastData.checks.year.info.type}`);
    if(lastData.checks.month.hit) ftsParts.push(`Month: ${lastData.checks.month.info.type}`);
    if(lastData.checks.day.hit)   ftsParts.push(`Day: ${lastData.checks.day.info.type}`);
    if(lastData.checks.time.hit)  ftsParts.push(`Time: ${lastData.checks.time.info.type}`);
    const ftsCN = ftsParts.length ? ftsParts.join("; ") : "None";

    const timeHit = lastData.hasTime && lastData.checks.time.hit;
    const flySelected = $("flyChk").checked===true;

    const tags=[];
    if(timeHit && flySelected) tags.push("+Fly FU 1x.");

    const userMsg = ($("userNoteBox").value || "").trim();
    const msgPart = userMsg ? ` Msg: ${userMsg}` : "";

    return (`${lastData.name}, ${westernPretty}, Lunar ${lastData.lunarStr}  ${gzStr} - ${ftsCN}. ${tags.join(" ")}${msgPart}`)
      .replace(/\s+/g," ").trim();
  }

  function refreshNoteBox(){
    $("dataNoteBox").value = buildCompactNoteLine();
  }

  function refreshOrderUI(){
    if(!lastData) return;

    const minNeed = lastData.minNeed;
    const base = getSuggestedBase(minNeed);
    const extra = clampInt($("extraQty").value,0,99);
    $("extraQty").value=extra;

    $("minNeed").textContent=String(minNeed);
    $("suggestTotal").textContent=String(base+extra);

    const timeHit = lastData.hasTime && lastData.checks.time.hit;
    if(timeHit){
      $("flyBlock").style.display="block";
      if(mode==="suggested") $("flyChk").checked=true;
    }else{
      $("flyBlock").style.display="none";
      $("flyChk").checked=false;
    }

    $("qty").value = clampInt($("qty").value,1,99);
  
    refreshOfferingLine();
}

  function refreshAll(){
    refreshOrderUI();
    refreshNoteBox();
  }

  function showSevereIfNeeded(totalMatches){
    const box=$("severeBox");
    if(totalMatches>=3){
      box.style.display="block";
      $("severeText").textContent = `You have ${totalMatches} Fan Tai Sui hits. Strongly suggest do not ignore.`;
    }else{
      box.style.display="none";
      $("severeText").textContent="-";
    }
  }

  async function getCartCount(){
    const r = await fetch("/cart.js", {
      headers:{ "Accept":"application/json" },
      cache:"no-store",
      credentials:"same-origin"
    });
    const c = await r.json();
    return (c && typeof c.item_count==="number") ? c.item_count : 0;
  }

  async function buildAll(){
    hideAlert();
    hideSuccess();

    const name=($("name").value||"").trim();
    const dob=$("dob").value;
    const tob=$("tob").value;

    if(!name){ showAlert("Please enter your Taoist name."); return null; }
    if(!dob){ showAlert("Please choose your western date of birth."); return null; }
    if(typeof Solar==="undefined"){ showAlert("Calendar engine blocked on this browser. Please open in Chrome/Safari."); return null; }

    const parts=dob.split("-").map(x=>parseInt(x,10));
    const y=parts[0], m=parts[1], d=parts[2];

    let hasTime=false, hh=0, mm=0;
    if(tob && tob.includes(":")){
      const tp=tob.split(":");
      hh=parseInt(tp[0],10); mm=parseInt(tp[1],10);
      if(!Number.isNaN(hh) && !Number.isNaN(mm)) hasTime=true;
    }

    const usedH = hasTime ? hh : 12;
    const usedM = hasTime ? mm : 0;

    const solar = makeSolar(y,m,d,usedH,usedM);
    const lunar = solar.getLunar();

    const gzYear  = safeCall(lunar, ["getYearInGanZhiExact","getYearInGanZhi"], "");
    const gzMonth = safeCall(lunar, ["getMonthInGanZhiExact","getMonthInGanZhi"], "");
    const gzDay   = safeCall(lunar, ["getDayInGanZhiExact","getDayInGanZhi"], "");
    const gzTime  = hasTime ? safeCall(lunar, ["getTimeInGanZhi","getHourInGanZhi"], "") : "";

    const zhiYear  = safeCall(lunar, ["getYearZhiExact","getYearZhi"], "")   || branchFromGanZhi(gzYear);
    const zhiMonth = safeCall(lunar, ["getMonthZhiExact","getMonthZhi"], "") || branchFromGanZhi(gzMonth);
    const zhiDay   = safeCall(lunar, ["getDayZhiExact","getDayZhi"], "")     || branchFromGanZhi(gzDay);
    const zhiTime  = hasTime ? (safeCall(lunar, ["getTimeZhi","getHourZhi"], "") || branchFromGanZhi(gzTime)) : "";

    const ly = safeCall(lunar, ["getYear"], "");
    let lm = safeCall(lunar, ["getMonth"], "");
    const ld = safeCall(lunar, ["getDay"], "");
    let isLeap=false;
    if(typeof lm==="number" && lm<0){ isLeap=true; lm=Math.abs(lm); }
    const lunarStr = `${ly}-${pad2(lm)}-${pad2(ld)}${isLeap ? " (leap month)" : ""}`;

    const westernShow = hasTime ? `${name} — ${dob} ${tob}` : `${name} — ${dob}`;
    const gzPillars = hasTime
      ? `Year: ${gzYear} | Month: ${gzMonth} | Day: ${gzDay} | Time: ${gzTime}`
      : `Year: ${gzYear} | Month: ${gzMonth} | Day: ${gzDay} | Time: (not provided)`;

    const checks = {
      year:  fanCheck("Year",  zhiYear),
      month: fanCheck("Month", zhiMonth),
      day:   fanCheck("Day",   zhiDay),
      time:  hasTime ? fanCheck("Time", zhiTime) : { text:"Time: (not provided)", hit:false, zhi:"" }
    };

    const totalMatches = [checks.year.hit, checks.month.hit, checks.day.hit, checks.time.hit].filter(Boolean).length;
    const suggestItems = buildSuggestions(checks, hasTime);
    const minNeed = suggestItems.reduce((sum,it)=>sum+(it.fu||0),0);

    $("results").style.display="block";
    $("gzPillars").textContent=gzPillars;
    $("lunarNums").textContent=lunarStr;
    $("westernShow").textContent=westernShow;

    $("ftYear").textContent=checks.year.text;
    $("ftMonth").textContent=checks.month.text;
    $("ftDay").textContent=checks.day.text;
    $("ftTime").textContent=checks.time.text;
    $("ftTotal").textContent=`${totalMatches} match(es)`;

    showSevereIfNeeded(totalMatches);
    renderSuggestList(suggestItems);

    lastData = { name,dob,tob,hasTime,gzYear,gzMonth,gzDay,gzTime,lunarStr,checks,totalMatches,suggestItems,minNeed };

    hideSuccess();
    mode="suggested";
    $("suggestModeBox").style.display="block";
    $("customModeBox").style.display="none";
    $("extraQty").value = 0;
    $("qty").value = 1;

    refreshAll();
    return lastData;
  }

  async function addToCart(){
    hideAlert();
    hideSuccess();

    if(!lastData){
      showAlert("Please click Confirm first.");
      return;
    }

    if(typeof rpc !== "function"){
      showAlert("SLB backend not ready. Please re-open Saam Law BaseStation.");
      return;
    }

    refreshAll();

    const qty = getCurrentQuantity();
    const topUp = clampInt(($("ftsTopUp")||{}).value, 0, 999999);
    if($("ftsTopUp")) $("ftsTopUp").value = topUp;

    const pouchSel = $("ftsPouchSel");
    const pouchId = pouchSel ? String(pouchSel.value||"").trim() : "";
    if(!pouchId){
      showAlert("Please select which Cosmic Pouch to pay from.");
      return;
    }

    const flyFlag = ($("flyFlag") && $("flyFlag").checked) ? 1 : 0;

    // Use the compact note line (short) + append user's extra note if any
    const noteLine = buildCompactNoteLine();
    const userExtra = String(($("userNoteBox")||{}).value||"").trim();
    const fullNote = (userExtra ? (noteLine + " | " + userExtra) : noteLine).trim();

    const total = (BASE_OFFER + topUp) * qty;
    const btn = $("addToCartBtn");
    if(btn){
      btn.disabled = true;
      btn.textContent = "Submitting...";
    }

    try{
      const payload = {
        payAccountId: pouchId,
        globalNote: "",
        lines: [{
          itemId: ITEM_ID,
          qty: qty,
          topUp: topUp,
          flyFu: flyFlag,
          note: fullNote
        }]
      };

      await rpc("templeOrderCreateBulk", payload);

      showSuccess("Submitted. Go to Temple → My Requests to review.");

      // reset only the payment fields (keep inputs/results so user can re-check)
      if(pouchSel) pouchSel.value = "";
      if($("ftsTopUp")) $("ftsTopUp").value = "0";
      refreshOfferingLine();
    }catch(e){
      const msg = (e && e.message) ? e.message : String(e||"");
      showAlert(msg || "Submit failed.");
    }finally{
      if(btn){
        btn.disabled = false;
        btn.textContent = "Submit Fan Tai Sui Request";
      }
    }
  }


  // Bind taps safely on mobile
  bindTap($("confirmBtn"), buildAll);
  bindTap($("addToCartBtn"), addToCart);

  $("switchToCustomBtn").addEventListener("click", ()=>setMode("custom"));
  $("switchToSuggestedBtn").addEventListener("click", ()=>setMode("suggested"));

  $("extraQty").addEventListener("input", ()=>{ if(!lastData) return; hideSuccess(); refreshAll(); });
  $("flyChk").addEventListener("change", ()=>{ if(!lastData) return; hideSuccess(); refreshAll(); });

  $("userNoteBox").addEventListener("input", ()=>{ if(!lastData) return; hideSuccess(); refreshAll(); });

  function adjustCustomQty(delta){
    $("qty").value = clampInt($("qty").value,1,99) + delta;
    $("qty").value = clampInt($("qty").value,1,99);
    if(!lastData) return;
    hideSuccess();
    refreshAll();
  }
  $("minusQty").addEventListener("click", ()=>adjustCustomQty(-1));
  $("plusQty").addEventListener("click", ()=>adjustCustomQty(1));
  $("qty").addEventListener("change", ()=>{ $("qty").value=clampInt($("qty").value,1,99); if(!lastData) return; hideSuccess(); refreshAll(); });
  // goCartBtn removed in SLB
$("clearBtn").addEventListener("click", ()=>{
    hideAlert(); hideSuccess();
    $("name").value=""; $("dob").value=""; $("tob").value="";
    $("extraQty").value=0; $("qty").value=1; if($("ftsTopUp")) $("ftsTopUp").value=0; if($("ftsPouchSel")) $("ftsPouchSel").value=""; refreshOfferingLine();
    $("dataNoteBox").value=""; $("userNoteBox").value="";
    $("results").style.display="none"; $("severeBox").style.display="none";
    const cc=$("cartCount"); if(cc) cc.textContent="0";
    lastData=null; mode="suggested";
    window.scrollTo({ top:0, behavior:"smooth" });
  });

  // === SLB hooks ===
  // Load pouches list and keep offering total updated
  loadPouches();
  refreshOfferingLine();

  const topUpEl = $("ftsTopUp");
  if(topUpEl){
    topUpEl.addEventListener("input", ()=>{ hideSuccess(); refreshOfferingLine(); });
    topUpEl.addEventListener("change", ()=>{ hideSuccess(); refreshOfferingLine(); });
  }

  const pouchSelEl = $("ftsPouchSel");
  if(pouchSelEl){
    pouchSelEl.addEventListener("change", ()=>{ hideSuccess(); });
  }


  }

  // Run after DOM is ready
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  }else{
    boot();
  }
})();
